/**
 * Created by jv on 06/02/2017.
 */
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const LoginManager = require("Sources/services/login-manager");
const StorageController = require("Sources/services/storage-controller");

//styles
require("Styles/pages/store/store-login.scss");

$(function()
{
  LanguageManager.init(function()
  {
    storeLogin.init();
  }, Shared.defaultLocale);
});

var storeLogin = {};

(function(StoreLogin)
{
  StoreLogin.init = function()
  {
    setUpEventListeners();
  };

  function setUpEventListeners()
  {
    $("#register-btn").on("click", function(e)
    {
      var qsReferer = utils.getQueryParam("referrer");

      if(utils.isNullOrEmpty(qsReferer))
      {
        utils.redirect("/store/register");
      }
      else
      {
        utils.redirect("/store/register?referrer=" + qsReferer);
      }
    });

    $("#password-input").on("keyup", function(e)
    {
      if(e.keyCode === 13)
      {
        handleLoginEvent();
      }
    });

    $("#login-btn").on("click", function(e)
    {
      handleLoginEvent();
    });
  }

  function handleLoginEvent()
  {
    var usernameEl = $("#username-input").removeClass("input-error"),
        passwordEl = $("#password-input").removeClass("input-error"),
        username = utils.removeWhitespace(usernameEl.val()),
        password = utils.removeWhitespace(passwordEl.val()),
        valid = true;

    if(utils.isNullOrEmpty(username))
    {
      valid = false;
      usernameEl.addClass("input-error");
    }

    if(utils.isNullOrEmpty(password))
    {
      valid = false;
      passwordEl.addClass("input-error");
    }

    if(valid)
    {
      login(username, password);
    }
    else
    {
      Shared.Dialog.showMessageDialog("store.login.dialog.empty_fields.title", "store.login.dialog.empty_fields.text");
    }
  }

  function login(username, password)
  {
    LoginManager.login(username, password,
      function(referer, loginData)
      {
        StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, loginData);

        var qsReferer = utils.getQueryParam("referrer");

        if(utils.isNullOrEmpty(qsReferer))
        {
          qsReferer = "/store/catalog";
        }

        utils.redirect(qsReferer);
      },
      function()
      {
        //Failed
        console.error("Failed to login");
        Shared.Dialog.showMessageDialog("store.login.dialog.failed.title", "store.login.dialog.failed.text");
      }
    );
  }

}(storeLogin));



// WEBPACK FOOTER //
// ./app/js/entries/store/store-login.js